import React from 'react';
import { Box } from '@mui/material';

const ContentContainer = ({
    withoutMargin = false,
    children,
    colorBg = false,
}: {
    withoutMargin?: boolean;
    children: React.ReactNode;
    colorBg?: boolean;
}) => {
    return (
        <Box
            sx={{
                width: '100%',
                justifyContent: 'center',
                display: 'flex',
                overflow: 'hidden',
                backgroundColor: colorBg ? '#F6F9FC' : undefined,
            }}
        >
            <Box
                sx={{
                    maxWidth: withoutMargin ? '1256px' : '1216px',
                    width: '100%',
                    margin: withoutMargin ? '' : '0 20px',
                }}
            >
                {children}
            </Box>
        </Box>
    );
};
export default ContentContainer;
